import React from 'react';
import { Target, TrendingUp } from 'lucide-react';

export default function AvgPositionCard() {
  return (
    <div className="bg-white border border-[#e7e7e7] rounded-[5px] p-5 hover:shadow-[rgba(150,25,50,0.1)_0px_10px_30px] transition-all duration-200 hover:-translate-y-0.5">
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-xs font-500 uppercase tracking-wide text-[#696969] mb-1">
            Avg. Position
          </p>
          <p className="text-3xl font-700 tabular-nums text-[#39364E]">
            1.4
          </p>
          <p className="text-xs text-[#696969] mt-1">Branded queries</p>
        </div>
        {/* Smarty-style icon wrapper: teal bg */}
        <div
          className="w-[50px] h-[50px] rounded-[5px] flex items-center justify-center"
          style={{ backgroundColor: 'rgb(217, 243, 246)' }}
        >
          <Target size={22} className="text-[#39364E]" />
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 border border-emerald-200">
          <TrendingUp size={11} className="text-emerald-600" />
          <span className="text-[11px] font-600 text-emerald-700 tabular-nums">+0.2</span>
        </div>
        <span className="text-[11px] text-[#696969]">improvement</span>
      </div>
      <p className="text-[11px] text-[#696969] mt-3">
        Lower is better · <span className="font-500 text-emerald-600">Excellent</span> visibility
      </p>
    </div>
  );
}